export const dashboardConstants = {
  BANNER_TYPE_LOGIN_WEB: "Login Web",
  BANNER_TYPE_HOME_BANNER: "Home Banner",

  DASHBOARD_ACCOUNTS_LIST_REQUEST: "DASHBOARD_ACCOUNTS_LIST_REQUEST",
  DASHBOARD_ACCOUNTS_LIST_SUCCESS: "DASHBOARD_ACCOUNTS_LIST_SUCCESS",
  DASHBOARD_ACCOUNTS_LIST_ERROR: "DASHBOARD_ACCOUNTS_LIST_ERROR",

  DASHBOARD_BANNER_LIST_REQUEST: "DASHBOARD_BANNER_LIST_REQUEST",
  DASHBOARD_BANNER_LIST_SUCCESS: "DASHBOARD_BANNER_LIST_SUCCESS",
  DASHBOARD_BANNER_LIST_ERROR: "DASHBOARD_BANNER_LIST_ERROR",

  DASHBOARD_ACCOUNT_HISTORY_LIST_REQUEST:
    "DASHBOARD_ACCOUNT_HISTORY_LIST_REQUEST",
  DASHBOARD_ACCOUNT_HISTORY_LIST_COMPLETE:
    "DASHBOARD_ACCOUNT_HISTORY_LIST_COMPLETE",
  DASHBOARD_ACCOUNT_HISTORY_LIST_ERROR: "DASHBOARD_ACCOUNT_HISTORY_LIST_ERROR",

  DASHBOARD_SECURE_MAIL_NOTIFICATION_REQUEST:
    "DASHBOARD_SECURE_MAIL_NOTIFICATION_REQUEST",
  DASHBOARD_SECURE_MAIL_NOTIFICATION_SUCCESS:
    "DASHBOARD_SECURE_MAIL_NOTIFICATION_SUCCESS",
  DASHBOARD_SECURE_MAIL_NOTIFICATION_ERROR:
    "DASHBOARD_SECURE_MAIL_NOTIFICATION_ERROR",
  DASHBOARD_SECURE_MAIL_NOTIFICATION_CLEAR:
    "DASHBOARD_SECURE_MAIL_NOTIFICATION_CLEAR",
  DASHBOARD_CLEAR_ACCOUNT_HISTORY_LIST: "DASHBOARD_CLEAR_ACCOUNT_HISTORY_LIST",

  CLEAR_LOGIN_WEB_BANNERS_LIST: "CLEAR_LOGIN_WEB_BANNERS_LIST",
};
